export const data = [
    {
        pic: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/4ka34495o11k2a/433d974387f12c6a8cbbeae3f98f94f4d62cbba5.jpg",
        title: "GTA Online",
        release_date: "January 27,2022",
        description: `Your Chariot Has Arrived:The Declasse Granger 3600LX,Available Now`
    },
    {
        pic: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/ak7k77927798k7/be138ee0d713d606232182e0944ddfead44f8570.jpg",
        title: "GTA Online",
        release_date: "January 20,2022",
        description: "Introducing The Obey I-Wagon,An Environmentally Responsible SUV"
    },
    {
        pic: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/51k1k9a2a577k9/1aa87bd28d2adc56467e0659d3d3c922da51b823.jpg",
        title: "GTA Online",
        release_date: "January 14,2022",
        description: "Double Down:A New Co-Op Experience in GTA Online"
    },
    {
        pic: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/o3a345a87o78a2/27b9732e6239d7cf826ae03c3abe2ea711cc6e0f.jpg",
        title: "Red Dead Online",
        release_date: "January 6,2022",
        description: "Start the New Year Off with Bonuses on A Land of Opportunities Missions,Call to Arms,Gang Hideouts,and the Featured Series"
    },
    {
        pic: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/k434939947914o/3e367a534b895ecd72d37116c55ba65a48b666e4.jpg",
        title: "GTA Online",
        release_date: "January 6,2022",
        description: "Inspire Envy with the New Pfister Comet S2 Cabrio"
    },
    {
        pic: "https://media-rockstargames-com.akamaized.net/tina-uploads/posts/393o535a972113/b9000dd0c31d045b4cd0a56dbe842f5b2f77ce94.jpg",
        title: "GTA Online",
        release_date: "December 30,2021",
        description: "Now Available:The Mammoth Patriot Mil-Spec"
    }
]